import isUndefined from 'lodash/isUndefined';
import get from 'lodash/get';
import {
    PROTECTION_PLAN_MESSAGES_SECTION_ID,
    PROTECTION_PLAN_MESSAGE_ID,
} from 'yoda-site-components/lib/components/ProtectionPlan/ProtectionPlan.config';
import { parseBannerMessage, ERROR_BANNER } from './bannerUtils';

export const protectionPlanErrorMessage = (ProtectionPlanMessages) => ({
    section: PROTECTION_PLAN_MESSAGES_SECTION_ID,
    message: {
        id: `${PROTECTION_PLAN_MESSAGE_ID}MessageId`,
        title: ProtectionPlanMessages ? ProtectionPlanMessages.requiredFieldMessage : '',
    },
});

function capitalize(str) {
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
}

export const isValidATCForm = (props, options) => {
    const {
        productOptions,
        customOptions,
        customOptionsFieldsErrors,
        additionalProtectionPlans,
        selectedProtectionPlan,
        messagesTexts: { ProductOptionsMessages, ProtectionPlanMessages },
        featureFlags: { enableErrorSizing },
    } = props;

    const ignoreProtectionPlan = get(options, 'ignoreProtectionPlan', false);
    const result = {
        invalid: false,
        messages: [],
    };
    if (productOptions.dimensions.length !== productOptions.optionsSelected.length) {
        // istanbul ignore next
        const selectedOptionsTypes = productOptions.optionsSelected.map((option) => option.type);
        const dimensionIds = [];
        result.messages = [
            ...result.messages,
            ...productOptions.dimensions
                .filter((dimension) => !selectedOptionsTypes.includes(dimension.id))
                .map(({ id, name }) => {
                    !dimensionIds.includes(id.toLowerCase()) &&
                        dimensionIds.push(name.toLowerCase());
                    return {
                        section: id,
                        message: {
                            id: `${id}MessageId`,
                            title: ProductOptionsMessages.requiredFieldMessage.replace(
                                '$1',
                                capitalize(name)
                            ),
                        },
                    };
                }),
        ];

        if (enableErrorSizing) {
            if (result.messages.length > 0) {
                const errorATCbannerDimensions = parseBannerMessage(dimensionIds);
                result.messages.push({
                    section: ERROR_BANNER,
                    message: {
                        id: ERROR_BANNER,
                        title: errorATCbannerDimensions,
                        options: dimensionIds,
                        type: 'warning',
                    },
                });
            }
        }
    }

    /* istanbul ignore next */
    if (
        customOptions.options &&
        customOptionsFieldsErrors &&
        Object.keys(customOptionsFieldsErrors).length
    ) {
        result.invalid = true;
    }

    return result;
};

const validateAddToCartForm = (props, options) => {
    // List of validations here...
    const requiredFields = isValidATCForm(props, options); // this.validateRequiredFields();

    return {
        invalid:
            [requiredFields.messages].some((arr) => arr.length > 0) ||
            [requiredFields.invalid].some((invalid) => invalid === true),
        messages: [...requiredFields.messages],
    };
};

export const checkItemAvailability = (props) => {
    let isItemAvailable = true;
    let toolTipMessage = '';
    const {
        productOptions: { filteredItems },
        deliveryOption,
        deviceType,
        promiseDeliveryOptions,
    } = props;
    const shipToHomeOrStore =
        promiseDeliveryOptions && Object.keys(promiseDeliveryOptions.shipToHomeOrStore).length > 0
            ? promiseDeliveryOptions.shipToHomeOrStore
            : deliveryOption.shipToHomeOrStore;
    const sameDayPickUp =
        promiseDeliveryOptions && Object.keys(promiseDeliveryOptions.shipToHomeOrStore).length > 0
            ? promiseDeliveryOptions.sameDayPickUp
            : deliveryOption.sameDayPickUp;
    const cartItems = filteredItems && filteredItems.length ? filteredItems : [];
    const sameDayPickupAvailable =
        sameDayPickUp && !isUndefined(sameDayPickUp.isSameDayPickupDisabled)
            ? !sameDayPickUp.isSameDayPickupDisabled
            : false;
    const shipToHomeOrStoreAvailable =
        shipToHomeOrStore && !isUndefined(shipToHomeOrStore.isshipToStoreDisabled)
            ? !shipToHomeOrStore.isshipToStoreDisabled
            : false;
    const maxQuantityAvailable =
        (shipToHomeOrStore && shipToHomeOrStore.isQuantityAvailable) || sameDayPickupAvailable;

    if (cartItems.length === 0) {
        isItemAvailable = false;
        if (deviceType.isDesktop) {
            toolTipMessage = 'Out Of Stock';
        }
    } else if (cartItems.length === 1) {
        isItemAvailable =
            maxQuantityAvailable &&
            (cartItems[0].atp || sameDayPickupAvailable || shipToHomeOrStoreAvailable);
        if (deviceType.isDesktop && !isItemAvailable && !cartItems[0].atp) {
            toolTipMessage = 'Out Of Stock';
        } else if (deviceType.isDesktop && !isItemAvailable) {
            toolTipMessage = 'Out Of Stock. Sign up to be alerted when its back in stock';
        }
    } else {
        isItemAvailable = cartItems.some((item) => item.atp);
        if (deviceType.isDesktop && !isItemAvailable) {
            toolTipMessage = 'Out Of Stock. Sign up to be alerted when its back in stock';
        }
    }

    return { isItemAvailable, toolTipMessage };
};

export default validateAddToCartForm;
